var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "order-detail-wrapper"
    },
    [
      _c("div", { staticClass: "top-content same-content" }, [
        _c("div", { staticClass: "title" }, [_vm._v("\n      订单信息\n    ")]),
        _vm._v(" "),
        _c("div", { staticClass: "content-detail" }, [
          _c("div", { staticClass: "content-detail-wrapper" }, [
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("订单号：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.orderNo))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("状态：")]),
              _c("span", [
                _vm._v(_vm._s(_vm._f("statusFormat")(_vm.details.status)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("总运费：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.totalMoney))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("单价：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.price))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("代付费：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.paidMoney || ""))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("是否开发票：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.isBilling ? "是" : "否"))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("是否货到付款：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.sbustitude ? "是" : "否"))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("路线：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    (_vm.details.cityFrom || "") +
                      (_vm.details.districtFrom || "") +
                      "-" +
                      (_vm.details.cityTo || "") +
                      (_vm.details.districtTo || "")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("创建时间：")]),
              _c("span", [
                _vm._v(_vm._s(_vm._f("timeFormat")(_vm.details.createTime)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("提货时间：")]),
              _c("span", [
                _vm._v(_vm._s(_vm._f("timeFormat")(_vm.details.deliveryTime)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("确认送达时间：")]),
              _c("span", [
                _vm._v(_vm._s(_vm._f("timeFormat")(_vm.details.completeTime)))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "handling-content" }, [
            _c("div", { staticClass: "handling-title" }, [
              _vm._v("\n          货物总计："),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.details.totalWeight) +
                    "吨；" +
                    _vm._s(_vm.details.pickupDrop)
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "handling-detail" },
              _vm._l(_vm.details.goods, function(childItem, childIndex) {
                return _c(
                  "div",
                  { key: childIndex, staticClass: "handling-item" },
                  [
                    _c("div", { staticClass: "key" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(childIndex + 1) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "goods-name" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.isOld
                              ? childItem.category.name
                              : childItem.goodsName
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "goods-weight" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.isOld ? childItem.count : childItem.weight
                          ) +
                          "吨\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "route-details" }, [
                      _c("span", [_vm._v(_vm._s(childItem.addressFrom))]),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-right" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(childItem.addressTo))])
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-content same-content" }, [
        _c("div", { staticClass: "title" }, [_vm._v("\n      其他信息\n    ")]),
        _vm._v(" "),
        _c("div", { staticClass: "content-detail" }, [
          _c("div", { staticClass: "content-detail-wrapper" }, [
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("交易员姓名：")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.details.scheduler && _vm.details.scheduler.name)
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("交易员电话：")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.details.scheduler && _vm.details.scheduler.phone)
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", [_vm._v("车辆信息：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.details.truck && _vm.getTruckInfo(_vm.details.truck)
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item detail-item-diff" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("备注：")]),
              _c("span", [_vm._v(_vm._s(_vm.details.remark))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "details-btn-wrap" },
        [
          !_vm.isOld
            ? [
                _vm.isDelivered
                  ? _c(
                      "el-button",
                      {
                        key: 1,
                        attrs: { type: "primary" },
                        on: { click: _vm.sureService }
                      },
                      [_vm._v("确认送达")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isButton
                  ? [
                      _c(
                        "el-button",
                        {
                          key: 2,
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmQuotation }
                        },
                        [_vm._v("确认报价")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { key: 3, on: { click: _vm.refuseQuotation } },
                        [_vm._v("拒绝报价")]
                      )
                    ]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isTrajectory
            ? [
                _c(
                  "el-button",
                  {
                    key: 4,
                    attrs: { type: "primary" },
                    on: { click: _vm.viewingPath }
                  },
                  [_vm._v("查看轨迹")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    key: 5,
                    attrs: { type: "primary" },
                    on: { click: _vm.checkReceipt }
                  },
                  [_vm._v("查看回单")]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("refuse-dialog", {
        attrs: { dialogVisible: _vm.refuseVisible, id: _vm.details._id },
        on: {
          "update:dialogVisible": function($event) {
            _vm.refuseVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.refuseVisible = $event
          },
          success: _vm.getDetail
        }
      }),
      _vm._v(" "),
      _c("receipt-dialog", {
        attrs: {
          dialogVisible: _vm.receiptVisible,
          orderNo: _vm.details.orderNo,
          isOld: !!_vm.isOld,
          receiptArr: _vm.receiptArr
        },
        on: {
          "update:dialogVisible": function($event) {
            _vm.receiptVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.receiptVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c("view-path-dialog", {
        attrs: {
          dialogVisible: _vm.viewPathVisible,
          orderNo: _vm.details.orderNo
        },
        on: {
          "update:dialogVisible": function($event) {
            _vm.viewPathVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.viewPathVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7567f4ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7567f4ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/order/detail/index.vue
// module id = null
// module chunks = 